// extracted by mini-css-extract-plugin
export var SkipNav = "layouts-components-__SkipToContent-module___SkipNav";